<template>
  <v-card>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.product" :label="filtersLabel.product" :error-messages="errors.collect('product')" data-vv-name="product" :data-vv-as="filtersLabel.inter" v-validate="'param|max:4'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.description" :label="filtersLabel.productDesc" :error-messages="errors.collect('productDesc')" data-vv-name="productDesc" :data-vv-as="filtersLabel.productDesc" v-validate="'entry|max:40'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="polTypeList" v-model="filters.defPolType" :label="filtersLabel.defPolType" item-text="label" item-value="value" data-vv-name="defPolType" :data-vv-as="filtersLabel.defPolType" :error-messages="errors.collect('defPolType')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.polWordingUrl" :label="filtersLabel.polWordingUrl" :error-messages="errors.collect('polWordingUrl')" data-vv-name="polWordingUrl" :data-vv-as="filtersLabel.inter" v-validate="'param|max:4'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.brochureUrl" :label="filtersLabel.brochureUrl" :error-messages="errors.collect('brochureUrl')" data-vv-name="brochureUrl" :data-vv-as="filtersLabel.inter" v-validate="'param|max:4'"></v-text-field>
                    </v-flex>
                    <transition name="slide-x-transition" mode="out-in">
                      <v-layout row wrap v-if="showDetailFilters">
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.backDateAcceptDays" :label="filtersLabel.backDateAcceptDays" :error-messages="errors.collect('backDateAcceptDays')" data-vv-name="backDateAcceptDays" :data-vv-as="filtersLabel.inter" v-validate="'param|max:4'"></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.maxDaysBeforeCover" :label="filtersLabel.maxDaysBeforeCover" :error-messages="errors.collect('maxDaysBeforeCover')" data-vv-name="maxDaysBeforeCover" :data-vv-as="filtersLabel.inter" v-validate="'param|max:4'"></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.maxDaysCovered" :label="filtersLabel.maxDaysCovered" :error-messages="errors.collect('maxDaysCovered')" data-vv-name="maxDaysCovered" :data-vv-as="filtersLabel.inter" v-validate="'param|max:4'"></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.b2cTnc" :label="filtersLabel.b2cTnc" :error-messages="errors.collect('b2cTnc')" data-vv-name="b2cTnc" :data-vv-as="filtersLabel.inter" v-validate="'param|max:4'"></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.defBrn" :label="filtersLabel.defBrn" :error-messages="errors.collect('defBrn')" data-vv-name="defBrn" :data-vv-as="filtersLabel.inter" v-validate="'param|max:4'"></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-autocomplete :items="booleanList" v-model="filters.finInstOptCvr" :label="filtersLabel.finInstOptCvr" item-text="label" item-value="value" data-vv-name="finInstOptCvr" :data-vv-as="filtersLabel.finInstOptCvr" :error-messages="errors.collect('finInstOptCvr')" clearable></v-autocomplete>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-autocomplete :items="booleanList" v-model="filters.isTakaful" :label="filtersLabel.isTakaful" item-text="label" item-value="value" data-vv-name="isTakaful" :data-vv-as="filtersLabel.isTakaful" :error-messages="errors.collect('isTakaful')" clearable></v-autocomplete>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-autocomplete :items="booleanList" v-model="filters.inclGst" :label="filtersLabel.inclGst" item-text="label" item-value="value" data-vv-name="inclGst" :data-vv-as="filtersLabel.inclGst" :error-messages="errors.collect('inclGst')" clearable></v-autocomplete>
                        </v-flex>
                        <!-- branches list -->
                        <!-- <v-flex xl3 lg4 xs6>
                          <v-autocomplete :items="branchList" v-model="filters.defBrn" :label="filtersLabel.defBrn" item-text="label" item-value="value" data-vv-name="defBrn" :data-vv-as="filtersLabel.defBrn" :error-messages="errors.collect('defBrn')" clearable></v-autocomplete>
                        </v-flex> -->
                      </v-layout>
                    </transition>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn flat="flat" @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
              <v-btn color="secondary" class="white--text" slot="activator">
                <span>Columns</span>
                <v-icon right dark>mdi-table-column-plus-after</v-icon>
              </v-btn>
              <v-card>
                <v-card-text>
                  <template v-if="columns.length > 0">
                    <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                  </template>
                  <template v-else>
                    No column found
                  </template>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-card-title>
          <v-data-table v-bind:headers="listHeaders" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="index" :loading="loading" :no-data-text="noDataText">
            <template slot="items" slot-scope="props">
              <td v-for="column in selectedColumns" :key="column">
                {{props.item[column]}}
              </td>
              <td class="text-xs-right">
                <table-action :rowData="props" :review="checkAccess(['maidRatingReview'])" @review="doReview" :remove="checkAccess(['maidRatingReview'])" @remove="doPromptRemove(props.item)"></table-action>
              </td>
            </template>
          </v-data-table>
          <v-btn color="primary" dark class="mb-2" @click="doNewProduct">New Maid Product<v-icon>mdi-plus</v-icon></v-btn>
          <confirm v-model="promptRemove" @ok="doRemove">
            Are you sure that you want to delete the selected Product?
            <div class="title">{{deleteProduct}}</div>
          </confirm>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { listMixin } from '@/components/parameters/reusable/listMixins'
import MessageMixin from '@/mixins/message'
import { mapGetters } from 'vuex'
import { appID } from '@/const/underwriting'
import { PARAMETERS_APPID } from '@/store/types'
import { filterQuery, expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      columns: [
        { text: 'Product', value: 'desc' },
        { text: 'Default Policy Type', value: 'defPolType' },
        { text: 'Back Date Accept Days', value: 'backDateAcceptDays' },
        { text: 'Max Days Before Cover', value: 'maxDaysBeforeCover' },
        { text: 'Max Days Covered', value: 'maxDaysCovered' },
        { text: 'Financial Institution Option Covered', value: 'finInstOptCvr' },
        { text: 'Policy Wording Url', value: 'polWordingUrl' },
        { text: 'Brochure Url', value: 'brochureUrl' },
        { text: 'B2C TNC', value: 'b2cTnc' },
        { text: 'Is Takaful', value: 'isTakaful' },
        { text: 'Included GST', value: 'inclGst' },
        { text: 'Default Branch', value: 'defBrn' }
      ],
      selectedColumns: ['desc', 'defPolType', 'polWordingUrl', 'brochureUrl'],
      showDetailFilters: false,
      filtersLabel: {
        product: 'Product',
        productDesc: 'Product Description',
        defPolType: 'Default Policy Type',
        backDateAcceptDays: 'Back Date Accept Days',
        maxDaysBeforeCover: 'Max Days Before Cover',
        maxDaysCovered: 'Max Days Covered',
        finInstOptCvr: 'Financial Institution Option Covered',
        polWordingUrl: 'Policy Wording Url',
        brochureUrl: 'Brochure Url',
        b2cTnc: 'B2C TNC',
        isTakaful: 'Is Takaful',
        inclGst: 'Included GST',
        defBrn: 'Default Branch'
      },
      filters: {
        product: null,
        description: null,
        defPolType: null,
        backDateAcceptDays: null,
        maxDaysBeforeCover: null,
        maxDaysCovered: null,
        finInstOptCvr: null,
        polWordingUrl: null,
        brochureUrl: null,
        b2cTnc: null,
        isTakaful: null,
        inclGst: null,
        defBrn: null
      },
      loading: null,
      totalItems: 0,
      booleanList: [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ],
      polTypeList: [],
      deleteProduct: '',
      promptRemove: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    constAppID() {
      return appID
    },
    appID() {
      return this.$store.state.parameters.appID
    },
    productMenu() {
      return this.$store.state.productManagement.menu
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData(options) {
      await this.$store.commit(PARAMETERS_APPID, this.constAppID.MAID)
      const apiURI = this.productMenu.products
      const { page, rowsPerPage } = this.pagination
      let expand = {
        appId: this.appID,
        page: page - 1,
        size: rowsPerPage,
        options: options
      }
      if (apiURI) {
        const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.descending))
        if (result.data) {
          this.totalItems = result.data.totalElements
          const { data } = result.data
          if (data) {
            this.items = []
            this.polTypeList = result.data.polTypeList
            data.map((product) => {
              const convertProduct = {
                product: product.product,
                // for easy to search
                desc: product.product + ' - ' + product.desc,
                defPolType: product.defPolType,
                backDateAcceptDays: product.backDateAcceptDays,
                maxDaysBeforeCover: product.maxDaysBeforeCover,
                maxDaysCovered: product.maxDaysCovered,
                finInstOptCvr: product.finInstOptCvr,
                polWordingUrl: product.polWordingUrl,
                brochureUrl: product.brochureUrl,
                b2cTnc: this.formatTextLength(product.b2cTnc),
                isTakaful: this.formatBoolean(product.isTakaful),
                inclGst: this.formatBoolean(product.inclGst),
                defBrn: product.defBrn
              }
              this.items.push(convertProduct)
            })
            this.loading = false
          } else {
            this.items = []
          }
        }
      }
    },
    doClearFilters() {
      this.filters.product = null
      this.filters.description = null
      this.filters.defPolType = null
      this.filters.backDateAcceptDays = null
      this.filters.maxDaysBeforeCover = null
      this.filters.maxDaysCovered = null
      this.filters.finInstOptCvr = null
      this.filters.polWordingUrl = null
      this.filters.brochureUrl = null
      this.filters.b2cTnc = null
      this.filters.isTakaful = null
      this.filters.inclGst = null
      this.filters.defBrn = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    doReview(data) {
      this.$router.push({ name: 'maidProductReview', params: { product: data.item.product } })
    },
    doNewProduct() {
      this.$router.push({ name: 'maidProductReview', params: { product: 'new' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProduct = data
        this.deleteProduct = data.desc
      }
    },
    async doRemove() {
      const apiURI = this.productMenu.deleteProduct
      if (apiURI) {
        this.loading = true
        const expand = {
          product: this.selectedProduct.product
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.fetchData(true)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Product')
      }
    }
  },
  mounted() {
    Promise.all([this.fetchData(true)])
  },
  mixins: [
    MessageMixin,
    listMixin
  ]
}
</script>

<style>

</style>
